// import { Button } from 'rsuite';

import { useEffect, useState } from 'react';
import { Button, Checkbox } from 'rsuite';
import { useDiagnosis } from '../../contexts/diagnosis';
import { useNavigate } from 'react-router-dom';
import { CustomLoader } from '../../components/basic/loader';

export const ExaminationTNC = () => {
  const { diagnosis } = useDiagnosis();
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isChecked, setIsChecked] = useState<any>(false);
  useEffect(() => {
    console.log(diagnosis);
    if (!diagnosis) {
      navigate('/examination');
    }
  }, []);

  return !diagnosis ? (
    <>
      <CustomLoader />
    </>
  ) : (
    <div className="p-2 ">
      <div className="p-1 py-2 border-[2px] border-[--rs-gray-800] rounded-md text-base1 text-center text-[--rs-gray-800]">
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {diagnosis.term_and_rules.split('\n').map((item: any, index: number) => (
          <p key={index}>{item}</p>
        ))}
      </div>

      <p className="text-justify mt-3 text-basesm px-1" style={{ textAlignLast: 'center' }}>
        {diagnosis.terms_text_explain}
      </p>

      <div className="flex justify-center items-center text-[--rs-gray-800]">
        <Checkbox
          value={isChecked}
          onChange={(value, checked) => {
            setIsChecked(checked);
          }}
          dir="rtl">
          {diagnosis.terms_confirm_text}
        </Checkbox>
      </div>
      <div className="flex justify-around mt-3">
        <Button
          appearance="primary"
          className="btn-outline !text-[--rs-black] !rounded-xl !py-3 w-[30%]"
          disabled={!isChecked}
          onClick={() => {
            navigate('/examination/paid');
          }}>
          {' '}
          ادامه بده
        </Button>
        <Button
          appearance="subtle"
          className="btn-outline !text-[--rs-black] !rounded-xl !py-3 w-[30%]"
          onClick={() => {
            navigate('/examination');
          }}>
          {' '}
          بازگشت
        </Button>
      </div>
    </div>
  );
};
